import { render, staticRenderFns } from "./OnlyText.vue?vue&type=template&id=5ec3d800&scoped=true"
import script from "./OnlyText.vue?vue&type=script&lang=js"
export * from "./OnlyText.vue?vue&type=script&lang=js"
import style0 from "./OnlyText.vue?vue&type=style&index=0&id=5ec3d800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec3d800",
  null
  
)

export default component.exports